export const en = {
  conversations: {
    chooseAvatar: {
      title: 'Choose your AI Agent',
      subtitle: 'Feel at home with your choice',
      cta: {
        continue: 'Continue',
      },
    },
    testControls: {
      title: 'Start the video conversation',
      instructions:
        'Make sure your microphone and camera are working properly before you begin. You can do a quick test with the buttons on the right. Once you are ready, click "Start Conversation".',
      cta: {
        start: 'Start Conversation',
      },
    },
  },
};
